import Vue from "vue"
import VueRouter from "vue-router"
// import Login from "@/views/Login.vue"
import Contact from "@/views/Contact.vue"
import Dashboard from "@/views/Dashboard"
import History from "@/views/History"
import About from "@/views/About"

Vue.use(VueRouter)

const routes = [
  // {
  //   path: "/login",
  //   name: "Login",
  //   component: Login,
  //   // beforeEnter: beforeEnterLoginPage,
  // },
  {
    path: "/",
    name: "Dashboard",
    component: Dashboard,
  },
  {
    path: "/about/:type",
    name: "About",
    component: About,
  },
  {
    path: "/contact",
    name: "Contact",
    component: Contact,
  },
  {
    path: "/history",
    name: "History",
    component: History,
  },
  {
    path: "*",
    name: "NotFound",
    redirect: "/",
  },
]

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
})

export default router
